import { render, staticRenderFns } from "./CheckoutMainCardComponent.vue?vue&type=template&id=01480002"
import script from "./CheckoutMainCardComponent.vue?vue&type=script&lang=ts"
export * from "./CheckoutMainCardComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports